import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';

const AsyncSelectField = ({
  name,
  label,
  value,
  onChange,
  loadOptions,
  options,
  placeholder = 'Type to find',
  error,
  info,
  required,
  isDisabled,
  autoFocus,
}) => {
  const selectedValue = value ? { value, label: options.find(option => option.value === value)?.label } : null;

  return (
    <div className="form-group">
      {label && (
        <label className="form-label">
          {label}{required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        value={selectedValue}
        onChange={(selectedOption) => onChange({ target: { name, value: selectedOption?.value || '' } })}
        placeholder={placeholder}
        classNamePrefix="react-select"
        className={`react-select-container ${error ? 'is-invalid' : ''}`}
        isDisabled={isDisabled}
        autoFocus={autoFocus}
      />
      {info && <small className="form-text text-muted">{info}</small>}
      {error && (
        <div className="invalid-feedback mb-2" style={{ textAlign: 'left' }}>
          {error}
        </div>
      )}
    </div>
  );
};

AsyncSelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired,
  options: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  info: PropTypes.string,
};

export default AsyncSelectField;